var _polygon, _polygon2, _polygon3, _polygon4, _g, _polygon5, _polygon6, _polygon7, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPHeatingHeatPumpSw = function SvgPHeatingHeatPumpSw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684.2 480.2",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684.2 480.2"
  }, props), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "638.1,264.1 382.8,264.1 373,252.1 628.3,252.1",
    fill: "#FFFFFF"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "634,259.1 378.7,259.1 377.1,257.1 632.4,257.1",
    fill: "#DF1400"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "635.7,261.1 380.3,261.1 381.1,262.1 636.5,262.1",
    fill: "#787878"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "630.8,255.1 374.9,255.1 374.1,254.1 630,254.1",
    fill: "#787878"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "626.1,252.1 626.1,62.1 638.1,62.1 638.1,264.1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "631.1,257.1 631.1,62.1 633.1,62.1 633.1,259.1",
    fill: "#DF1400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "629.1,255.1 629.1,62.1 628.1,62.1 628.1,254.1",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "635.1,261.1 635.1,62.1 636.1,62.1 636.1,262.1",
    fill: "#787878"
  }))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "384.1,264.1 384.1,396.1 372.1,396.1 372.1,264.1 377.1,259.1 379.1,259.1",
    fill: "#FFFFFF"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "379.1,257.1 379.1,396.1 377.1,396.1 377.1,257.1",
    fill: "#DF1400"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "381.1,261.1 381.1,396.1 382.1,396.1 382.1,261.1",
    fill: "#787878"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 374.1,
    y: 254.1,
    width: 1,
    height: 142,
    fill: "#787878"
  })));
};
export default SvgPHeatingHeatPumpSw;